import { defineMessages } from "@/lib/i18n/messages";

// Formatos de fecha de los eventos (lib/api.ts los arma al traerlos del
// backend). Índices: weekday 0 = domingo, month 0 = enero.
const listEs = (items: string[]) =>
  items.length > 1 ? `${items.slice(0, -1).join(", ")} y ${items[items.length - 1]}` : items[0] ?? "";
const listEn = (items: string[]) =>
  items.length > 1 ? `${items.slice(0, -1).join(", ")} and ${items[items.length - 1]}` : items[0] ?? "";

export default defineMessages({
  es: {
    today: "Hoy",
    weekdayShort: ["Dom", "Lun", "Mar", "Mié", "Jue", "Vie", "Sáb"],
    monthShort: ["Ene", "Feb", "Mar", "Abr", "May", "Jun", "Jul", "Ago", "Sep", "Oct", "Nov", "Dic"],
    monthLong: ["enero", "febrero", "marzo", "abril", "mayo", "junio", "julio", "agosto", "septiembre", "octubre", "noviembre", "diciembre"],
    // "Sáb 11 Oct"
    shortDate: (weekday: string, day: number, month: string) => `${weekday} ${day} ${month}`,
    // "11 Oct"
    dayMonthShort: (day: number, month: string) => `${day} ${month}`,
    // "11 de octubre"
    dayMonthLong: (day: number, month: string) => `${day} de ${month}`,
    // "6, 13 y 20 de mayo"
    daysOfMonth: (days: number[], month: string) => `${listEs(days.map(String))} de ${month}`,
    // "6 – 11 Jun"
    rangeSameMonth: (from: number, to: number, month: string) => `${from} – ${to} ${month}`,
    range: (from: string, to: string) => `${from} – ${to}`,
    until: (date: string) => `Hasta ${date}`,
    ctaLabel: "Ver evento",
    errors: {
      events: "Error al cargar eventos",
      districts: "Error al cargar ubicaciones",
      title: "No se pudo cargar este título.",
      providers: "No se pudo cargar dónde verla.",
      leaveInvalid: "Este link ya no es válido o tus datos ya fueron eliminados.",
      leaveFailed: "No pudimos procesar tu solicitud. Intenta de nuevo.",
    },
  },
  en: {
    today: "Today",
    weekdayShort: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
    monthShort: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
    monthLong: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
    // "Sat, Oct 11"
    shortDate: (weekday: string, day: number, month: string) => `${weekday}, ${month} ${day}`,
    // "Oct 11"
    dayMonthShort: (day: number, month: string) => `${month} ${day}`,
    // "October 11"
    dayMonthLong: (day: number, month: string) => `${month} ${day}`,
    // "May 6, 13 and 20"
    daysOfMonth: (days: number[], month: string) => `${month} ${listEn(days.map(String))}`,
    // "Jun 6 – 11"
    rangeSameMonth: (from: number, to: number, month: string) => `${month} ${from} – ${to}`,
    range: (from: string, to: string) => `${from} – ${to}`,
    until: (date: string) => `Until ${date}`,
    ctaLabel: "View event",
    errors: {
      events: "Couldn't load events",
      districts: "Couldn't load locations",
      title: "Couldn't load this title.",
      providers: "Couldn't load where to watch it.",
      leaveInvalid: "This link is no longer valid or your data was already deleted.",
      leaveFailed: "We couldn't process your request. Please try again.",
    },
  },
});
